import { connect } from 'react-redux';
import * as actions from './actions';
import * as selectors from './selectors';
import ForgotPasswordComponent from './component';


const mapStateToProps = (state) => ({
  isPosting: selectors.getIsPosting(state),
  errMsg: selectors.getErrMsg(state),
});

const mapDispatchToProps = dispatch => ({
  onSubmitForgotPassword: (email) => {
    dispatch(actions.doSubmitForgotPassword(email));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordComponent);